<template>
  <div
    v-if="!loading"
    class="overflow-x-auto flex scrollbar-none space-x-3 -ml-4 sm:-ml-6 lg:ml-0 -mr-4 sm:-mr-6 lg:mr-0 pr-4 sm:pr-6 lg:pr-0 lg:space-x-0 lg:scrollbar-auto lg:overflow-x-auto lg:grid lg:grid-cols-2 lg:gap-4"
  >
    <button
      v-for="(review, index) in reviews"
      :key="index"
      type="button"
      class="w-80 h-52 shrink-0 p-5 flex flex-col text-left justify-between border border-neutral-00 rounded-md shadow-lg lg:w-auto first:ml-4 sm:first:ml-6 lg:first:ml-0"
      @click="$emit('review-clicked', $event)"
    >
      <span class="text-neutral-700 line-clamp-4">
        {{ review.body }}
      </span>
      <span class="flex flex-row">
        <vetster-client-image
          :name="review.author"
          size="sm"
          no-margin
        />
        <span class="flex flex-col my-auto ml-3 text-sm">
          <span class="font-medium text-neutral-900">
            {{ review.author }} {{ review.author_last_name }}
          </span>
          <span class="text-neutral-500">
            {{ getReviewDate(review.created_at) }}
          </span>
        </span>
      </span>
    </button>
  </div>
</template>

<script>
import { DateTime } from 'luxon';

import VetsterClientImage from '@/brand-components/VetsterClientImage';
import ParseErrors from '@/mixins/ParseErrors';

export default {
  name: 'VetsterReviews',

  components: { VetsterClientImage },

  mixins: [ParseErrors],

  props: {
    partner: {
      type: Object,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    defaultReviews: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      reviews: [],
      loading: false,
    };
  },

  watch: {
    partner: {
      handler() {
        this.fetchReviews();
      },
      deep: true,
    },
  },

  async created() {
    if (this.defaultReviews.length) {
      this.reviews = this.defaultReviews;
    } else {
      await this.fetchReviews();
    }
  },

  methods: {
    async fetchReviews() {
      try {
        this.loading = true;
        const response = await this.$api.get(`p/partner/${this.partner.uuid}/reviews`, {
          params: {
            page: 1,
            perPage: this.perPage,
          },
        });
        this.reviews = response.data.data;
      } catch (e) {
        this.showError(e, true);
      } finally {
        this.loading = false;
      }
    },
    getReviewDate(timestamp) {
      return DateTime.fromISO(timestamp)
        .toLocaleString({
          month: 'long',
          year: 'numeric',
        });
    },
  },
};
</script>
